export default [
    {
        key: "selected",
        label: "Selected",
        width: 2,
        sortable: false,
        sortAs: "timestamp",
        keyType: "text",
    },
    {
        key: "photo_url",
        label: "Avatar",
        width: 2,
        sortable: false,
        sortAs: "string",
        keyType: "avatar",
    },
    {
        key: "name",
        label: "Name",
        width: 3,
        sortable: false,
        sortAs: "string",
        keyType: "text",
    },
    {
        key: "description",
        label: "Description",
        width: 3,
        sortable: false,
        sortAs: "string",
        keyType: "text",
    },
    {
        key: "service_period",
        label: "Service Period",
        width: 2,
        sortable: false,
        sortAs: "string",
        keyType: "text",
    },
    {
        key: "status",
        label: "Status",
        width: 3,
        sortable: false,
        sortAs: "string",
        keyType: "text",
    },
    {
        key: "category",
        label: "Category",
        width: 3,
        sortable: false,
        sortAs: "string",
        keyType: "text",
    },
];
